var jade = require("/web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"modal-body\"><div class=\"modal-body-content\"><div class=\"text-center\"><h4 data-i18n=\"signup.select_your_starting_hero\"></h4><div data-i18n=\"signup.you_can_always_change_your_hero_later\" class=\"small\"></div></div><div id=\"hero-select-view\"></div></div><!-- In reverse order for tabbing purposes--><div class=\"history-nav-buttons\"><button type=\"button\" class=\"next-button btn btn-lg btn-navy\"><span data-i18n=\"common.next\"></span></button></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/core/create-account-modal/extras-view.jade
// module id = 844
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91